<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/18mu5eV/tc-custom/9781035826704.jpg?1708946616925" alt="This image is the cover for the book A Brief History of Disability"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">A Brief History of Disability
      </h1>
      <p class="bookDescription body article font2">
        <p>A hidden history of human evolution has been written, but very few people know about the history of disabled people who have been walking side by side able bodied people since the beginning of time. <br/>In this book we shall discover the two true elements which cause our bodies to change, biological and environmental changes that we all face before and during life. History has often regarded disabled people as ‘imperfect’, but what if they were special people who are unique, and a valuable part of the broader rainbow of human diversity? <br/>This book shall unlock the padlock into human history that has rarely been talked about before. There is more to us than originally thought.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Molly Seymour
      </h2>
      
      <p class="authorDescription body article">Molly Seymour is a young writer who got into writing because she wanted to find a creative way to inspire people, to get people talking about what she feels is an injustice in our society, particularly when it comes to disabled people. There is a loss off human potential as disabled people, a part of human evolution, are constantly ignored. Now even though disabilities aren’t seen as the ideal body type but behind their disability, the people are just the same as any one of us. We all have a desire to be loved, we all have a desire to be happy and we all certainly have a desire to be successful, no matter our background. By helping disabled people, Molly is helping humanity move forward to becoming a more accepting society and you can help her by supporting this book. Doing so, you are playing your part in humanity embracing humanity as a whole. Thankyou.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2dce2e6e